export default __webpack_public_path__ + "static/media/java.11e0b81d.svg";